export * from './useDeleteHtmlConfiguration';
export * from './useDeleteHtmlConfiguration.graphql';
export * from './useDeleteHtmlConfiguration.interfaces';
